// ##### Komarov 2025-08-02
import { isDataEncrypted } from '../../Components/Pages/Helpers/helper';
import {
  GET_SITE_CYPHER_CODE_DATA_RES,
  GET_SITE_CYPHER_CODE_DATA_ERR,
} from '../constants';

const initState = {
  value: null,
  description: null,
  isDataEncrypted: false,
  error: null,
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case GET_SITE_CYPHER_CODE_DATA_RES:
      // ##### Komarov 2025-08-02
      return {
        ...state,
        ...action.payload,
        isDataEncrypted: isDataEncrypted(action.payload.value),
      };

    case GET_SITE_CYPHER_CODE_DATA_ERR:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
